<div class="flex flex-col h-full w-full">
  <!-- Current Program Info (read-only) -->
  <div class="flex flex-col gap-4 mb-4">
    <prox-field label="Current Program Name">
      <input type="text" pInputText [disabled]="true" [(ngModel)]="oldProgram!.name" class="w-full" />
    </prox-field>
    <prox-field label="Program Accessibility">
      <input type="text" pInputText [disabled]="true" [(ngModel)]="oldProgram!.programStartDateType.name"
        class="w-full" />
    </prox-field>
    <div class="flex flex-row gap-4">
      <prox-field label="Start Date" class="flex-1">
        <input type="text" pInputText [disabled]="true" [value]="oldProgram!.startDate | date : 'MMM d, yyyy'"
          class="w-full" />
      </prox-field>
      <prox-field label="End Date" class="flex-1">
        <input type="text" pInputText [disabled]="true" [value]="oldProgram!.endDate | date : 'MMM d, yyyy'"
          class="w-full" />
      </prox-field>
    </div>
  </div>

  <!-- New Program Cycle Values -->
  <div class="flex flex-col gap-4 mb-4">
    <h4>New Program Cycle Values</h4>
    <prox-field label="New Program Name">
      <input type="text" pInputText [pAutoFocus]="true" [(ngModel)]="newData.newProgramName" class="w-full" />
    </prox-field>
    <div class="flex flex-row gap-4">
      <prox-field label="New Start Date" class="flex-1">
        <p-datepicker [(ngModel)]="newData.newStartDate" styleClass="w-full"></p-datepicker>
      </prox-field>
      <prox-field label="New End Date" class="flex-1">
        <p-datepicker [(ngModel)]="newData.newEndDate" styleClass="w-full"></p-datepicker>
      </prox-field>
    </div>
  </div>

  <!-- Button Bar -->
  <div class="flex pt-2 items-center">
    <p-button (onClick)="onProceed()" label="Proceed" icon="pi pi-check" styleClass="mr-2"></p-button>
    <p-button (onClick)="onCancel()" label="Cancel" icon="pi pi-times" styleClass="mr-2"></p-button>
  </div>
</div>